/** @format */
import React from 'react';

import { flags } from '@toucan/config/country-flags';

import { FlagWrapper } from './market-flag.styles';
import { FlagProps } from './types';

export const Flag = ({
    marketCode,
    'data-testid': dataTestId = 'market-selector',
}: FlagProps) => {
    const MarketFlag = flags[marketCode];

    if (!MarketFlag) {
        return null;
    }

    const flagDataTestId = `${dataTestId}__${marketCode.toLowerCase()}`;

    return (
        <FlagWrapper data-testid={flagDataTestId}>
            <MarketFlag />
        </FlagWrapper>
    );
};
